export default "__VITE_ASSET__CeHNsy7s__";